(function() {
  let klaviyoSearchButton = setInterval(() => {
    let signUpButton = document.querySelector('.footer__signup button');

    if (signUpButton != null) {
      clearInterval(klaviyoSearchButton);

      signUpButton.addEventListener('click', () => {
        let klaviyoFormInterval = setInterval(() => {
          let klaviyoError = document.querySelector('#klaviyo_ariaid_2');

          if(klaviyoError != null) {
            let errorField = document.querySelector('.footer__signupError');

            errorField.innerText = klaviyoError.innerText;
            errorField.classList.add('footer__signupError--active');
            clearInterval(klaviyoFormInterval);

            setTimeout(() => {
              errorField.classList.remove('footer__signupError--active');
            }, 3000);
          } else {
            let successMessage = document.querySelector('.footer__signupSuccess'),
                signUpForm = document.querySelector('.footer__signupForm');

            successMessage.classList.add('footer__signupSuccess--active');
            signUpForm.remove();
            clearInterval(klaviyoFormInterval);
          }
        }, 100);
      });
    }
  }, 100);

  const footer = document.querySelector('.footer__wrapper');
  const menuTitles = document.querySelectorAll('.footerMenu__title');

  function toggleMenu(e) {
    e.preventDefault();

    const currentMenu = e.currentTarget.closest('.footerMenu');
    const currentList = currentMenu.querySelector('.footerMenu__list');

    currentMenu.classList.toggle('footerMenu--active');
    currentList.classList.toggle('footerMenu__list--active');

    if (currentMenu.classList.contains('footerMenu--active')) {
      currentList.style.maxHeight = `${currentList.scrollHeight}px`;
    } else {
      currentList.style.maxHeight = '0px';
    }
  }

  if (window.innerWidth <= 960) {
    menuTitles.forEach((title) => {
      title.addEventListener('click', toggleMenu);
    });
  }
})();
